
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Label } from '@/components/ui/label';

interface PhoneOtpVerificationProps {
  verifyPhoneOtp: (otp: string) => Promise<void>;
  resendCode: () => void;
  loading: boolean;
  onVerified: () => void;
}

export const PhoneOtpVerification = ({ 
  verifyPhoneOtp,
  resendCode,
  loading,
  onVerified
}: PhoneOtpVerificationProps) => {
  const [phoneOtp, setPhoneOtp] = useState('');
  const [error, setError] = useState<string | null>(null);
  
  const handleVerifyPhone = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!phoneOtp) return;
    
    setError(null);
    
    try {
      await verifyPhoneOtp(phoneOtp);
      onVerified();
    } catch (error: any) {
      setError(error.message || 'Failed to verify phone OTP');
    }
  };
  
  return (
    <form onSubmit={handleVerifyPhone} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="phoneOtp">SMS Verification Code</Label>
        <Input
          id="phoneOtp"
          type="text"
          placeholder="Enter SMS verification code"
          value={phoneOtp}
          onChange={(e) => setPhoneOtp(e.target.value)}
          maxLength={6}
          disabled={loading}
        />
        <p className="text-xs text-muted-foreground">
          Check your phone for a 6-digit verification code
        </p>
      </div>
      
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      <Button 
        type="submit" 
        disabled={!phoneOtp || loading}
        className="w-full"
      >
        {loading ? 'Verifying...' : 'Verify Phone'}
      </Button>
      
      <Button
        type="button"
        variant="outline"
        onClick={resendCode}
        disabled={loading}
        className="w-full mt-2"
      >
        Resend SMS Code
      </Button>
    </form>
  );
};
